function Footer() {
    return (
        <footer className="footer">
            Copyright Benjamin Moody, 2023
        </footer>
    )

}

export default Footer;